import styled from 'styled-components';

interface ContainerProps {
    isSelected: boolean
}

export const Container = styled.div<ContainerProps>`
    cursor: pointer;
    width: 100%;
    > li {
        background: ${(props) => (props.isSelected ? props.theme.backgroundColor : 'white')};
    }
}
`;
